import React from 'react';
import PropTypes from 'prop-types';
import {useComponentProps} from 'helpers/hooks/utils';
import {useTable} from 'components/organisms/Providers/TableProvider/TableProvider';
import StyledDatabaseEntitiesViewsWrapper
  from 'components/templates/Wrappers/Database/DatabaseEntitiesViewsWrapper/DatabaseEntitiesViewsWrapper.styles';
import DatabaseEntitiesTableViews
  from 'components/organisms/TableViews/DatabaseEntitiesTableViews/DatabaseEntitiesTableViews';

const DatabaseEntitiesViewsWrapper = React.forwardRef((props, ref) => {
  const innerProps = useComponentProps(props, 'DatabaseEntitiesViewsWrapper');

  const tableProvider = useTable();

  return <StyledDatabaseEntitiesViewsWrapper ref={ref} {...innerProps}
                                             variant="foldout"
                                             context={<DatabaseEntitiesTableViews />}
                                             open={Boolean(tableProvider.state?.showViews)}
                                             size="oversize"
                                             ContextDrawerProps={{
                                               onToggle: (e, open) => {
                                                 if (open) {
                                                   tableProvider.openViews();
                                                 } else {
                                                   tableProvider.closeViews();
                                                 }
                                               }
                                             }}>
    {innerProps.children}
  </StyledDatabaseEntitiesViewsWrapper>
});

DatabaseEntitiesViewsWrapper.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ])
};

export default DatabaseEntitiesViewsWrapper;
